import React from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Button, Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import clsx from 'clsx';
import ListItemsSubMenu from '../ListItemsSubMenu';
import { ListItemsMenuProps } from './ListItemsMenu.props';

const ListItemsMenu = ({
  menuItem,
  open,
  activeFirstLevel,
  handleMenu,
  classes,
  openDropDown,
  handleSubMenu,
  companySlugParam,
  fundSlugParam,
}: ListItemsMenuProps) => {
  const { title, slug, icon, subMenu, filterComponent } = menuItem;

  const subMenuProps = {
    menuItem,
    classes,
    openDropDown,
    handleSubMenu,
    companySlugParam,
    fundSlugParam,
  };

  return (
    <div key={slug} data-testid={slug}>
      <ListItem
        id={`sidebar-menu-${slug}`}
        component={Button}
        selected={activeFirstLevel === slug}
        className={`${classes.item} sidebar-menu-first-level`}
        onClick={event => handleMenu(event, menuItem)}>
        <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
        {open && <ListItemText primary={title} className={classes.itemText} />}
        {open && subMenu && (activeFirstLevel === slug ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>

      <Collapse in={open && activeFirstLevel === slug} timeout="auto" unmountOnExit className={classes.subMenu}>
        {filterComponent && <ListItem className={clsx(classes.subitem)}>{filterComponent}</ListItem>}
        <List component="div" disablePadding>
          {menuItem.actionMenu && (
            <ListItemsSubMenu
              idIndex={subMenu?.length ? subMenu.length + 1 : 0}
              subMenuItem={menuItem.actionMenu}
              key={`${menuItem.actionMenu.slug}-${subMenu?.length ? subMenu.length + 1 : 0}`}
              {...subMenuProps}
            />
          )}
          {subMenu?.map((subMenuItem, index) => (
            <ListItemsSubMenu
              idIndex={subMenuItem.id ?? index}
              subMenuItem={subMenuItem}
              key={`${subMenuItem.slug}-${subMenuItem.id}`}
              {...subMenuProps}
            />
          ))}
        </List>
      </Collapse>
    </div>
  );
};

export default ListItemsMenu;
